const React = require("react");
const T = React.PropTypes; 

require("./NotChrome.less");

const Main = require("../Main/Main.jsx");
const MajorMessage = require("../MajorMessage/MajorMessage.jsx"); 

const NotChrome = React.createClass({
    render () {
        
        return (<div className="cs-NotChrome__Root">
                <div className="cs-NotChrome">
                <img src="https://cubecontent.azureedge.net/cdn/cubie-glasses.jpg" />
                <h2>SmartAudit doesn't support this browser</h2>
                <h3>Please use <a href="https://www.google.com/chrome/browser/">Google Chrome</a></h3>
                </div>
                </div>); 
    }

});

module.exports = NotChrome; 


// WEBPACK FOOTER //
// ./src/components/NotChrome/NotChrome.jsx